<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="35%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="speakerFormRules" ref="speakerFormRef" label-width="100px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_img"
            name="img"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="avatarUrl" :src="avatarUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input>
      </el-form-item>
      <el-form-item label="管理员等级" prop="admin_level">
        <el-input-number v-model="formData.admin_level" :step="1" :max="255" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item v-if="id > 0" label="状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" filterable>
          <el-option label="正常" :value="10"></el-option>
          <el-option label="隐藏" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序值" prop="sort">
        <el-input-number v-model="formData.sort" :step="1"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'speaker_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加讲员',
      formData: {
        name: '',
        avatar: '',
        intro: '',
        admin_level: 0,
        status: 10,
        sort: 0
      },
      avatarUrl: '',
      speakerFormRules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        avatar: [
          { required: true, message: '头像不能为空', trigger: 'blur' }
        ],
        intro: [
          { required: true, message: '介绍不能为空', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.speakerFormRef.resetFields()
      this.avatarUrl = ''
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.speakerFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.avatarUrl = ''
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑讲员'
        this.getInfo(this.id)
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/speaker/info/' + id)
      if (res.code === 0) {
        this.formData = {
          name: res.data.name,
          avatar: res.data.avatar,
          intro: res.data.intro,
          admin_level: res.data.admin_level,
          status: res.data.status,
          sort: res.data.sort
        }
        this.avatarUrl = res.data.avatar_url
      }
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.avatarUrl = resp.data.url
        this.formData.avatar = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
